inputmode attribute:
<form>
    <mat-form-field appearance="fill">
        <mat-label>none</mat-label>
        <input matInput inputmode="none" />
    </mat-form-field><br />

    <mat-form-field appearance="fill">
        <mat-label>decimal</mat-label>
        <input matInput inputmode="decimal" />
    </mat-form-field><br />

    <mat-form-field appearance="fill">
        <mat-label>numeric</mat-label>
        <input matInput inputmode="numeric" />
    </mat-form-field><br />

    <mat-form-field appearance="fill">
        <mat-label>tel</mat-label>
        <input matInput inputmode="tel" />
    </mat-form-field><br />

    <mat-form-field appearance="fill">
        <mat-label>search</mat-label>
        <input matInput inputmode="search" />
    </mat-form-field><br />

    <mat-form-field appearance="fill">
        <mat-label>email</mat-label>
        <input matInput inputmode="email" />
    </mat-form-field><br />

    <mat-form-field appearance="fill">
        <mat-label>url</mat-label>
        <input matInput inputmode="url" />
    </mat-form-field><br />
</form>